import Ui from '../../../client/ui.js'

export default class _common
{
	static init()
	{
		$('.__lazy').lazyload()

		this.scroll_hash()
		App.common.Network.init()
	}

	static menu_toggle()
	{
		if(Ui.is_mobile()) $('nav').slideToggle()
	}

	static scroll_hash()
	{
		if(!location.hash) return

		const anchor = $(location.hash)
		if(anchor.length === 0) return

		document.body.scrollTop = 0
		window.scrollTo(0, 0)

		$('html, body').animate({
			scrollTop: anchor.offset().top - 10,
		}, 1000)
	}
}
